<script>
import Service from '../../../services/fiscal-notification';
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import GenericCustomMasterDataAutocompleteV2 from '../../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
        GenericCustomMasterDataAutocompleteV2,
        ResponsiveButton,
  },
  data(){
    return {
      filters: {
        from:  Utils.formatDatePlusDays(new Date(), -1),
        to:  Utils.formatDatePlusDays(new Date(), -1),
        idRegitryPlant: null,
      },
      liquidProducts: [],
      gasProducts: [],
      tableLoading: false,
      actualExciseDueGasSubTotal: 0,
      actualExciseDutyGasSubTotal: 0,
      actualExciseDueLiquidSubTotal: 0,
      actualExciseDutyLiquidSubTotal: 0,
      previewExciseDueGasSubTotal: 0,
      previewExciseDueLiquidSubTotal: 0,
      previewExciseDutyGasSubTotal: 0,
      previewExciseDutyLiquidSubTotal: 0
    }
  },
  validations(){
    return {
      filters: {
        from: {required},
        to: {required},
        macroProductCode: {},
      }
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'Hter9.page_title');
  },
  methods: {
    resetData(){
      this.liquidProducts = [];
      this.gasProducts = [];
      this.actualExciseDueGasSubTotal = 0;
      this.actualExciseDutyGasSubTotal = 0;
      this.actualExciseDueLiquidSubTotal = 0;
      this.actualExciseDutyLiquidSubTotal = 0;
      
      this.previewExciseDueGasSubTotal = 0;
      this.previewExciseDueLiquidSubTotal = 0;
      this.previewExciseDutyGasSubTotal = 0;
      this.previewExciseDutyLiquidSubTotal = 0;
    },
     load(){
        this.submitted = true;

        if(this.v$.invalid){
            return;
        }
        this.submitted = false;

        this.resetData();

        let filters = {
            from: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.from, 0)),
            to: Utils.formatDateForAPI(Utils.formatEndDate(this.filters.to)),
            idRegitryPlant: this.filters.idRegitryPlant
        }
        this.tableLoading= true;
        Service.getHter9(filters, response => {
            this.tableLoading = false;
            if(response.success){
              this.liquidProducts = response.data.liquidItems;
              this.gasProducts = response.data.gasItems;

              this.actualExciseDueGasSubTotal = response.data.actualExciseDueGasSubTotal;
              this.actualExciseDutyGasSubTotal = response.data.actualExciseDutyGasSubTotal;
              this.actualExciseDueLiquidSubTotal = response.data.actualExciseDueLiquidSubTotal;
              this.actualExciseDutyLiquidSubTotal = response.data.actualExciseDutyLiquidSubTotal;

              this.previewExciseDueGasSubTotal = response.data.previewExciseDueGasSubTotal;
              this.previewExciseDueLiquidSubTotal = response.data.previewExciseDueLiquidSubTotal;
              this.previewExciseDutyGasSubTotal = response.data.previewExciseDutyGasSubTotal;
              this.previewExciseDutyLiquidSubTotal = response.data.previewExciseDutyLiquidSubTotal;
            }
        })

    },
    dowloadReport(){
        this.$store.dispatch("generic/setLoading", true);
        let filters = {
           from: Utils.formatDateForAPIWithTime(Utils.formatDatePlusDays(this.filters.from, 0)),
            to: Utils.formatDateForAPIWithTime(Utils.formatEndDate(this.filters.to)),
            idRegitryPlant: this.filters.idRegitryPlant
        }
        Service.printHter9(filters, response => {
            
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                let fileName = "HTER9.pdf";
                fileLink.setAttribute('download',fileName);
                document.body.appendChild(fileLink);
            
                fileLink.click();
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        })
    }
  }
}

</script>

<template>
  <main>
    <div class="grid">
        <div class="col-12 lg:col-2">
            <label for="from" :class="{'p-error':v$.filters.from.$invalid && submitted}">{{$t('from')}}</label>
            <Calendar
                :class="{'p-invalid':v$.filters.from.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.from"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div v-if="(v$.filters.from.$invalid && submitted) || v$.filters.from.$pending.$response">
                <small class="p-error" v-for="error in v$.filters.from.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
            </div>
        <div class="col-12 lg:col-2">
            <label for="to" :class="{'p-error':v$.filters.to.$invalid && submitted}">{{$t('to')}}</label>
            <Calendar
                :class="{'p-invalid':v$.filters.to.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.to"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            <div v-if="(v$.filters.to.$invalid && submitted) || v$.filters.to.$pending.$response">
                <small class="p-error" v-for="error in v$.filters.to.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
            </div>
        </div>
        <div class="col-12 lg:col-2">
            <label for="plant">{{$t('registryPlant.fk')}}</label>
            <GenericCustomMasterDataAutocompleteV2
                field="label"
                v-model="filters.idRegitryPlant"
                api="masterdata/registry-plant-combo"
                :addEmpty="true"
                :emptyValue="null"
                :emptyLabel="$t('all')"
                :name="'registry-plant'"
                :class="{'p-inputtext-sm w-full': true}" />
        </div>
        <div class="col-12 lg:col-6">
            <div class="p-4">
                <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" class="mx-1" @click="load()"/>   
                <ResponsiveButton :label="$t('btn.download')" icon="pi pi-download" class="mx-1" @click="dowloadReport"/>   
            </div>
        </div>
        <div class="col-12" style="height: calc(75vh)">
          <TabView>
            <TabPanel :header="$t('Hter9.liquids')">
                <DataTable :value="liquidProducts" tableStyle="min-width: 50rem" :loading="tableLoading"
                rowGroupMode="subheader">
                  <Column field="productMacroCode" :header="$t('Hter9.productMacroCode')" sortable />
                  <Column field="note" />
                  <Column field="destination"  />
                  <Column field="movementType" :header="$t('Hter9.movementType')" sortable />
                  <Column field="fiscalPosition" :header="$t('Hter9.fiscalPosition')" sortable />
                  <Column field="movedWeight" :header="$t('Hter9.movedWeight')" sortable >
                    <template #body="slotProps">
                        {{ utils.formatInteger(slotProps.data.movedWeight) }}
                    </template>
                  </Column>
                  <Column field="movedVolume" :header="$t('Hter9.movedVolume')" sortable  >
                    <template #body="slotProps">
                        {{ utils.formatInteger(slotProps.data.movedVolume) }}
                    </template>
                  </Column>
                  <Column field="taxableQuantity" :header="$t('Hter9.taxableQuantity')" sortable >
                    <template #body="slotProps">
                        {{ utils.formatInteger(slotProps.data.taxableQuantity) }}
                    </template>
                  </Column>
                  <Column field="exciseRate" :header="$t('Hter9.exciseRate')" sortable  >
                    <template #body="slotProps">
                        {{ utils.formatDecimal(slotProps.data.exciseRate,7) }}
                    </template>
                    <template #footer> 
                        {{ $t('Hter9.today') }}
                        <br />
                        <br />
                        <br />
                        {{ $t('Hter9.prev') }}
                        <br />
                        <br />
                        <br />
                        {{ $t('Hter9.total') }}
                    </template>  
                  </Column>
                  <Column field="exciseDue" :header="$t('Hter9.exciseDue')" sortable  >
                    <template #body="slotProps">
                        {{ utils.formatDecimal(slotProps.data.exciseDue,3) }}
                    </template>
                    <template #footer> 
                      {{ utils.formatDecimal(actualExciseDueLiquidSubTotal,3 ) }}
                      <br />
                      <br />
                      <br />
                       {{ utils.formatDecimal(previewExciseDueLiquidSubTotal,3 ) }}
                      <br />
                      <br />
                      <br />
                       {{ utils.formatDecimal(actualExciseDueLiquidSubTotal + previewExciseDueLiquidSubTotal,3 ) }}
                    </template>  
                  </Column>
                  <Column field="exciseDuty" :header="$t('Hter9.exciseDuty')" sortable >
                    <template #body="slotProps">
                        {{ utils.formatDecimal(slotProps.data.exciseDuty,3) }}
                    </template>
                    <template #footer> 
                      {{ utils.formatDecimal(actualExciseDutyLiquidSubTotal,3 ) }}
                      <br />
                      <br />
                      <br />
                       {{ utils.formatDecimal(previewExciseDutyLiquidSubTotal,3 ) }}
                      <br />
                      <br />
                      <br />
                       {{ utils.formatDecimal(actualExciseDutyLiquidSubTotal + previewExciseDutyLiquidSubTotal,3 ) }}
                    </template>  
                  </Column>
              </DataTable>
            </TabPanel>
            <TabPanel :header="$t('Hter9.gas')">
                <DataTable :value="gasProducts" tableStyle="min-width: 50rem" :loading="tableLoading">
                  <Column field="productMacroCode" :header="$t('Hter9.productMacroCode')" sortable />
                  <Column field="note" />
                  <Column field="destination"  />
                  <Column field="movementType" :header="$t('Hter9.movementType')" sortable />
                  <Column field="fiscalPosition" :header="$t('Hter9.fiscalPosition')" sortable />
                  <Column field="movedWeight" :header="$t('Hter9.movedWeight')" sortable >
                    <template #body="slotProps">
                        {{ utils.formatInteger(slotProps.data.movedWeight) }}
                    </template>
                  </Column>
                  <Column field="movedVolume" :header="$t('Hter9.movedVolume')" sortable  >
                    <template #body="slotProps">
                        {{ utils.formatInteger(slotProps.data.movedVolume) }}
                    </template>
                  </Column>
                  <Column field="taxableQuantity" :header="$t('Hter9.taxableQuantity')" sortable >
                    <template #body="slotProps">
                        {{ utils.formatInteger(slotProps.data.taxableQuantity) }}
                    </template>
                  </Column>
                  <Column field="exciseRate" :header="$t('Hter9.exciseRate')" sortable  >
                    <template #body="slotProps">
                        {{ utils.formatDecimal(slotProps.data.exciseRate,7) }}
                    </template>
                    <template #footer> 
                        {{ $t('Hter9.today') }}
                        <br />
                        <br />
                        <br />
                        {{ $t('Hter9.prev') }}
                        <br />
                        <br />
                        <br />
                        {{ $t('Hter9.total') }}
                    </template>  
                  </Column>
                  <Column field="exciseDue" :header="$t('Hter9.exciseDue')" sortable  >
                    <template #body="slotProps">
                        {{ utils.formatDecimal(slotProps.data.exciseDue,3) }}
                    </template>
                    <template #footer> 
                      {{ utils.formatDecimal(actualExciseDueGasSubTotal,3 ) }}
                      <br />
                      <br />
                      <br />
                       {{ utils.formatDecimal(previewExciseDueGasSubTotal,3 ) }}
                      <br />
                      <br />
                      <br />
                       {{ utils.formatDecimal(actualExciseDueGasSubTotal + previewExciseDueGasSubTotal,3 ) }}
                    </template>  
                  </Column>
                  <Column field="exciseDuty" :header="$t('Hter9.exciseDuty')" sortable >
                    <template #body="slotProps">
                        {{ utils.formatDecimal(slotProps.data.exciseDuty,3) }}
                    </template>
                    <template #footer> 
                      {{ utils.formatDecimal(actualExciseDutyGasSubTotal,3 ) }}
                      <br />
                      <br />
                      <br />
                       {{ utils.formatDecimal(previewExciseDutyGasSubTotal,3 ) }}
                      <br />
                      <br />
                      <br />
                       {{ utils.formatDecimal(actualExciseDutyGasSubTotal + previewExciseDutyGasSubTotal,3 ) }}
                    </template>  
                  </Column>
              </DataTable>
            </TabPanel>
          </TabView>
        </div>
    </div>
  </main>
</template>